/**
 * 一条评价
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Rating from "@components/rating";

class Comment extends Component {
  renderCommentBody() {
    const { comment } = this.props;
    const body = (comment || {}).body || "";
    return body
      .trim()
      .split(/\s*(?:\r\n|\r|\n)\s*/g)
      .map((line, lineNo) => <p key={lineNo}>{line}</p>); // eslint-disable-line
  }

  render() {
    const { className, comment, userId } = this.props;
    return (
      <div
        className={cx("comment-card", {
          [`${className}`]: className,
        })}
      >
        <div className="comment-card__header clearfix">
          <img
            className="comment-card__avatar pull-left"
            src={comment.userAvatarUrl || require("@shared/images/avatar-default.png")}
            alt="用户头像"
          />
          <div className="comment-card__user">
            <div>
              {comment.userNickName}
              {userId && userId !== comment.guestId ? <i className="comment-card__user-tag">房客</i> : null}
            </div>
            <Rating value={comment.totalScore} />
          </div>
        </div>
        <div className="comment-card__body">{this.renderCommentBody()}</div>
        {comment.picModelList && comment.picModelList.length > 0 ? (
          <ul className="comment-card__pics list-inline">
            {comment.picModelList.map(item => (
              <li>
                <img src={item.url} alt="" />
              </li>
            ))}
          </ul>
        ) : null}
        {comment.hostReply ? <div className="comment-card__reply">房东回复：{comment.hostReply}</div> : ""}
      </div>
    );
  }
}

Comment.defaultProps = {
  className: null,
  userId: null,
};

Comment.propTypes = {
  className: PropTypes.string,
  comment: PropTypes.object.isRequired,
  userId: PropTypes.number, // 当前登录用户ID
};

export default Comment;

require("./index.less");
require("./index.less");